import { useEffect, useState } from "react";

export function useOfficeReady() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (typeof Office === "undefined") return;
    Office.onReady().then(() => setReady(true));
  }, []);

  return ready;
}
